import React, { useState } from 'react';
import { cn } from '../../ui/utils';

function getInitials(name) {
  if (!name?.trim()) return 'U';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
}

export default function ChatAvatar({ src, name, isUser, className }) {
  const [imgError, setImgError] = useState(false);
  const hasValidSrc = Boolean(src?.trim()) && !imgError;
  const showInitials = isUser && !hasValidSrc;
  const imageSrc = hasValidSrc ? src : !isUser ? '/cw-avatar.png' : null;

  if (showInitials) {
    return (
      <div
        className={cn(
          'flex h-8 w-8 shrink-0 items-center justify-center self-end rounded-full bg-primary text-xs font-semibold text-primary-foreground ring-2 ring-border/40 md:h-9 md:w-9 md:text-sm',
          className
        )}
        aria-label={name || 'You'}
      >
        {getInitials(name)}
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={name || (isUser ? 'You' : 'Classwise AI')}
      onError={() => setImgError(true)}
      className={cn(
        'h-8 w-8 shrink-0 self-end rounded-full object-cover ring-2 ring-border/40 md:h-9 md:w-9',
        className
      )}
    />
  );
}
